<div class="orders-page">
    <!-- =====================================================
         HERO
    ====================================================== -->
<section class="orders-hero">
    <div class="orders-hero__content">
        <!-- TÍTULO -->
        <div class="orders-hero__heading">
            <p class="orders-eyebrow">
                MI CUENTA
            </p>
            <h1>
                Mis <span class="nina-brand-italic">pedidos</span>
            </h1>
            <p class="orders-hero__subtitle">
                Consulta el estado y detalle de tus compras.
            </p>
        </div>
        <!-- NINA RECOMPENSAS -->
        <div class="orders-rewards-card">
            <div class="orders-rewards-card__content">
                <span class="orders-rewards-card__title">
                    Nina Recompensas
                </span>
                <div class="orders-rewards-card__points">
                    <strong>
                        {{ userPointsData?.puntos || 0 }}
                    </strong>
                    <span>
                        puntos
                    </span>
                </div>
                <p>
                    Canjea tus puntos por promociones exclusivas
                    y descuentos en pasteles, pays y postres.
                </p>
            </div>
            <div class="orders-rewards-card__value">
                <span>
                    1 punto = $1
                </span>
            </div>
            <mat-icon class="orders-rewards-card__star">
                star_outline
            </mat-icon>
        </div>
    </div>
</section>
    <!-- =====================================================
         CONTENIDO
    ====================================================== -->
    <main class="orders-container">
        <!-- =================================================
             CON PEDIDOS
        ================================================== -->
        <ng-container *ngIf="ordersHistory.length > 0">
            <div class="orders-layout">
                <!-- =================================================
                     LISTA DE PEDIDOS
                ================================================== -->
                <section class="orders-list">
                    <div class="orders-section-header">
                        <div>
                            <span class="orders-section-eyebrow">
                                HISTORIAL
                            </span>
                            <h2>
                                Tus pedidos
                            </h2>
                        </div>
                        <span class="orders-count">
                            {{ ordersHistory.length }}
                            {{ ordersHistory.length === 1 ? 'pedido' : 'pedidos' }}
                        </span>
                    </div>
                    <!-- =================================================
                         PEDIDOS
                    ================================================== -->
                    <div class="orders-cards">
                        <article class="order-card" *ngFor="let sale of ordersHistory">
                            <!-- =============================================
                                 HEADER PEDIDO
                            ============================================== -->
                            <div class="order-card__header">
                                <div class="order-card__heading">
                                    <span class="order-card__eyebrow">
                                        PEDIDO
                                    </span>
                                    <h3>
                                        Folio {{ sale.idVenta }}
                                    </h3>
                                </div>
                                <div class="order-card__actions">
                                    <button *ngIf="sale.estatus" mat-flat-button class="order-status"
                                        [ngClass]="'order-status--' + sale.uiState.color">
                                        {{ sale.uiState.label }}
                                    </button>
                                    <button *ngIf="
                                            !sale.esPedidoPickAndGo &&
                                            sale.orderIdStandBy?.length > 0 &&
                                            sale.uiState.showTracking
                                        " type="button" class="order-tracking-button"
                                        (click)="openDialogTracking(sale)">
                                        <mat-icon>
                                            local_shipping
                                        </mat-icon>
                                        <span>
                                            Rastrear envío
                                        </span>
                                    </button>
                                </div>
                            </div>
                            <!-- =============================================
                                 PRODUCTOS
                            ============================================== -->
                            <div class="order-card__products">
                                <div class="order-product" *ngFor="let product of sale.detalle">
                                    <!-- IMAGEN -->
                                    <div class="order-product__image-wrapper">
                                        <img class="order-product__image" [src]="product.urlFoto"
                                            [defaultImage]="defImgProd" [alt]="product.descripcion">
                                    </div>
                                    <!-- INFORMACIÓN -->
                                    <div class="order-product__info">
                                        <strong>
                                            {{ product.descripcion }}
                                        </strong>
                                        <span>
                                            Cantidad: {{ product.cantidad }}
                                        </span>
                                    </div>
                                    <!-- PRECIOS -->
                                    <div class="order-product__prices">
                                        <span>
                                            {{
                                            product.precio
                                            | currency:'USD':'symbol':'1.0-0'
                                            }}
                                            c/u
                                        </span>
                                        <strong>
                                            {{
                                            product.total
                                            | currency:'USD':'symbol':'1.0-0'
                                            }}
                                        </strong>
                                    </div>
                                </div>
                            </div>
                            <!-- =============================================
                                 TOTAL
                            ============================================== -->
                            <div class="order-card__footer">
                                <span>
                                    Total del pedido
                                </span>
                                <strong>
                                    {{
                                    sale.importe
                                    | currency:'USD':'symbol':'1.0-0'
                                    }}
                                </strong>
                            </div>
                        </article>
                    </div>
                </section>
                <!-- =================================================
                     VISUAL LATERAL
                ================================================== -->
            </div>
        </ng-container>
        <!-- =================================================
             SIN PEDIDOS
        ================================================== -->
        <section class="orders-empty" *ngIf="ordersHistory.length <= 0">
            <div class="orders-empty__card">
                <div class="orders-empty__image-wrapper">
                    <img src="../../../assets/img/voidhistory.jpg" alt="Sin pedidos" class="orders-empty__image">
                </div>
                <span class="orders-section-eyebrow">
                    HISTORIAL DE PEDIDOS
                </span>
                <h2>
                    Aún no tienes pedidos
                </h2>
                <p>
                    Cuando realices una compra, aquí podrás consultar
                    todos sus detalles y darle seguimiento.
                </p>
                <button class="orders-empty__button" mat-raised-button type="button"
                    (click)="router.navigate(['/store'])">
                    VER CATÁLOGO
                </button>
            </div>
        </section>
    </main>
</div>